import React, { useEffect, useState } from 'react'
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss'
import { unitPrice } from '../../../../../../../utils/product'
import { Iconfont } from '../../../../../../components/icon/iconfont'
import { FormattedMessage } from 'react-intl'
import ReactSlider from 'react-slider'

const FilterSelectedLine = props => {
	useStyles(classes)
	const {data, removeSelection} = props || {}

	return <React.Fragment>
		<div className={classes.SelectedCateGory}>
			<div className={classes.TagAll}>
			    <FormattedMessage id="all" defaultMessage={'All'} />{' >'}
			</div>
			<div className={classes.TagSelected}>
				{
					data && data.length > 0 &&
					data.map((d, index) => {
						return <div className={classes.SelectedCateGoryItem}key={d.value+index} onClick={()=>removeSelection(d)}>
							{d.label}
							<span className={classes.Del}></span>
						</div>
					})
				}
			</div>

		</div>
	</React.Fragment>
}

export const FilterSliders = props => {
	useStyles(classes)
    const [values, setValues] = useState(props.values || [0, 80])

    useEffect(() => {
        setValues(props.values)
    }, [props.values])

	const Track = (props, state) => {
		return <div {...props} className={`${classes.Track} ${state.index === 1 ?classes.TrackIndex1: classes.TrackIndex2}`}></div>
	}
	const Thumb = (props, state) =>
		<span {...props}>
			<span style={{width:18,height:18,borderRadius:'50%',backgroundColor:'#fff',boxShadow:'0 0 10px 1px rgba(34,34,34,0.1)',display:'inline-block',position:'absolute',top:-9,left:-9}}></span>
		</span>

    return <div >
        <div className={classes.SliderInfo}>
            <span>{unitPrice(values[0])}</span>
            <span>{unitPrice(values[1])}</span>
        </div>
        <div style={{marginTop: 16, paddingRight: 9, paddingLeft: 9}}>
            <ReactSlider
                style={{width: '100%',height:'1px'}}
                defaultValue={[values[0] ? values[0].amount || '0': '0', values[1] ? values[1].amount || '0': '0']}
                value={[values[0] ? values[0].amount || 0: 0, values[1] ? values[1].amount || 0: 0]}
                renderTrack={Track}
                renderThumb={Thumb}
                onAfterChange={(values) => {
                    props.onChange([values[0],values[1]])
                }}
                onChange={(v1, v2) => {
                    setValues([{...values[0], amount:v1[0]}, {...values[1], amount:v1[1]}])
                }}
                min={Number(props.min||0)}
                max={Number(props.max||100)}
            />
        </div>
    </div>
}

export const FilterSortBox = props => {
    useStyles(classes)
	const {
        selectHead,
        setSelectHead,
        beforeChangeData,

        sort,
        sorters,
        showSort,
        setShowSort,
        selectSort,

        selectedFilterItems,
        removeSelection,
        selectionClick,
        filterItems,
        showCategory,
        setShowCategory,
        categoryReset,
        categoryDone,

        showPrice,
        priceFilterChange,
        priceUnit,
        priceCurrency,
        startPrice,
        endPrice,
        defaultData,
        priceReset,
        priceDone,
        setShowPrice,

    } = props

    const formatePrice = (amount) => {
		return {amount: amount, unit: priceUnit, currency: priceCurrency}
	}

    const headClick = (type) => {
		if(type == 0){
			setSelectHead(0)
			setShowSort(!showSort)
			setShowCategory(false)
			setShowPrice(false)
		} else if(type == 1){
			setSelectHead(1)
			setShowSort(false)
			setShowCategory(!showCategory)
			setShowPrice(false)
		} else {
			setSelectHead(2)
			setShowSort(false)
			setShowCategory(false)
			setShowPrice(!showPrice)
		}
		beforeChangeData()
	}

	return <div className={classes.FilterSortBox}>
			<div className={classes.SortButtonLine}>
				<div onClick={() => {headClick(0)}}>
					<span className={`${selectHead == 0 ? classes.TabSelected:''}`}>
						<FormattedMessage id="sort" defaultMessage={'Sort'}></FormattedMessage>
						<Iconfont className={classes.SortIcon}>&#xe7e2;</Iconfont>
					</span>
				</div>
                <div onClick={() => {headClick(1)}}>
					<span className={`${selectHead == 1 ? classes.TabSelected:''}`}>
						<FormattedMessage id="category" defaultMessage={'Category'}></FormattedMessage>
						<Iconfont className={classes.SortIcon}>&#xe7e2;</Iconfont>
					</span>
				</div>
                <div onClick={() => {headClick(2)}}>
					<span className={`${selectHead == 2 ? classes.TabSelected:''}`}>
						<FormattedMessage id="price" defaultMessage={'Price'}></FormattedMessage>
						<Iconfont className={classes.SortIcon}>&#xe7e2;</Iconfont>
					</span>
				</div>
			</div>

			{
				showSort && <React.Fragment>
					<div className={classes.SortList}>
						{
							(sorters || []).map(sorter =>
                            <div onClick={evt => {selectSort(sorter)}}
                                 key={sorter.value}
                                 className={`${classes.SortItem} ${sort === sorter.value ? classes.SortItemActive : ''}`}>
								<span>{sorter.label}</span>
							</div>)
						}
					</div>

					<div className={classes.SortMask} onClick={() => {setShowSort(false)}} />
				</React.Fragment>
			}

			{
				showCategory && <React.Fragment>
					<div className={classes.SortList}>
						<div className={classes.CategoryBox}>
							{
								selectedFilterItems && selectedFilterItems.length > 0 &&
								<FilterSelectedLine data={selectedFilterItems} removeSelection={removeSelection}/>
							}
							{
								filterItems && filterItems.length > 0 &&
								filterItems.sort((a, b) => { return a.sort - b.sort })
											.map(selection =>
											<div className={`${classes.FilterItem} ${selection.selected ? classes.Active : ''}`}
                                                 onClick={evt => { selectionClick(selection) }}
												 key={selection.value}>
												{selection.label}
											</div>)
							}
						</div>

						<div className={`${classes.FilterButtons} ${classes.CategoryButtons}`}>
							<div className={`${classes.Reset}`} onClick={() => {categoryReset()}}><FormattedMessage id="reset" defaultMessage={'Reset'}/></div>
							<div className={`${classes.Done}`} onClick={() => {categoryDone()}}><FormattedMessage id="done" defaultMessage={'Done'}/></div>
						</div>
					</div>

                    <div className={classes.SortMask} onClick={() => {setShowCategory(false)}} />
				</React.Fragment>
			}

			{
				showPrice && <React.Fragment>
					<div className={classes.SortList}>
						{
							<div className={classes.FilterBox}>
								<div className={classes.FilterTitle}>
                                    <FormattedMessage id="price_range" values={{currency: priceCurrency}} defaultMessage={`Price Range(${priceCurrency})`}/>
                                </div>
								<div style={{ marginTop: 0 }}>
									<FilterSliders
										onChange={values => {priceFilterChange(values)}}
										values={[formatePrice(Number(startPrice)), formatePrice(Number(endPrice))]}
										min={0}
										max={defaultData?.endPrice || 0} />
								</div>

								<div className={`${classes.FilterButtons}`}>
									<div className={`${classes.Reset}`} onClick={() => {priceReset()}}><FormattedMessage id="reset" defaultMessage={'Reset'}/></div>
									<div className={`${classes.Done}`} onClick={() => {priceDone()}}><FormattedMessage id="done" defaultMessage={'Done'}/></div>
								</div>
							</div>
						}
					</div>

                    <div className={classes.SortMask} onClick={() => {setShowPrice(false)}} />
				</React.Fragment>
			}
		</div>
}